// extracted by mini-css-extract-plugin
module.exports = {"formTextArea":"jgp-35K2H"};